import React, { useRef } from 'react';
import TypingEffectPlaceholder from './TypingEffectPlaceholder';
import styles from './AssistantChatRow.module.css';

type AssistantChatRowProps = {
  input: string;
  setInput: (val: string) => void;
  isSmallScreen: boolean;
  onSend: (msg: string) => void;
  onPredefined: (msg: string) => void;
};

const PREDEFINED_QUESTIONS = [
  'What can you do?',
  'How can AstroStar help my business?'
];

const AssistantChatRow: React.FC<AssistantChatRowProps> = ({ input, setInput, isSmallScreen, onSend, onPredefined }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={styles.container + (isSmallScreen ? ' ' + styles.smallScreen : '')}
      style={isSmallScreen ? undefined : { margin: '5px auto', width: 'fit-content', maxWidth: '100vw' }}
    >
      {/* Left column: Chat image and text */}
      <div className={styles.leftCol} style={isSmallScreen ? undefined : { justifyContent: 'center', alignItems: 'center', minWidth: 260 }}>
        <div className={styles.titleRow + (isSmallScreen ? ' ' + styles.titleRowSmall : '')}>
          {/* <span role="img" aria-label="chat">💬</span> */}
          <span className={styles.titleText + (isSmallScreen ? ' ' + styles.titleTextSmall : '')}>Ask AstroStar</span>
        </div>
      </div>
      {/* Right column: Input and predefined questions */}
      <div className={styles.rightCol} style={isSmallScreen ? undefined : { justifyContent: 'center', alignItems: 'center', minWidth: 720 }}>
        <form
          onSubmit={e => {
            e.preventDefault();
            if (input.trim()) onSend(input);
          }}
          className={styles.form}
        >
          <div className={styles.inputWrapper}>
            <input
              ref={inputRef}
              type="text"
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder=""
              className={styles.input}
              aria-label="Ask AstroStar"
            />
            {/* Animated placeholder overlay */}
            <TypingEffectPlaceholder
              sentences={[
                "Ask me anything...",
                "Ask me about AstroStar products and services...",
                "Get help with AI agents, web, mobile, desktop apps...",
                "How can AstroStar help your business?"
              ]}
              inputValue={input}
              speed={45}
            />
            <button
              type="submit"
              className={styles.sendButton}
              aria-label="Send"
              tabIndex={input.trim() ? 0 : -1}
              disabled={!input.trim()}
            >
              {/* SVG send icon */}
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 25L25 14L3 3V12L19 14L3 16V25Z" fill="#00b1a2" />
              </svg>
            </button>
          </div>
          {/* Predefined questions */}
          {/* <div className={styles.predefinedRow}>
            {PREDEFINED_QUESTIONS.map(q => (
              <button
                key={q}
                type="button"
                onClick={() => onPredefined(q)}
                className={styles.predefinedButton}
              >
                {q}
              </button>
            ))}
          </div>  */}
        </form>
      </div>
    </div>
  );
};

export default React.memo(AssistantChatRow);